import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] border-t border-[#1a1a1a] py-12">
      <div className="max-w-7xl mx-auto px-5 sm:px-10 flex flex-col md:flex-row md:items-end justify-between gap-8">
        <div>
          <Logo />
          <p className="font-mono text-[11px] text-[#666] mt-4 max-w-sm leading-relaxed">
            White $19 - Black $20 until the timer hits zero. Pay with Cash App, Venmo, PayPal or
            card. Every order gets an email verification code.
          </p>
        </div>
        <p className="font-mono text-[10px] tracking-[0.15em] text-[#555] uppercase max-w-xs leading-relaxed">
          Independent reseller. Not affiliated with or endorsed by Supreme New York. Shipping not
          included in listed prices.
        </p>
      </div>
    </footer>
  );
}
